import React, { Component } from "react";
import { injectIntl } from "react-intl";
import AcknowledgementLayout from "../../../../Containers/common/acknowledgement";
import CloseIcon from "../../../../Assets/images/close.svg";
import {SecondaryButton, TertiaryButton} from "../../../Common/button";
import messages from "./messages";

class editDistributorProductCode extends Component {
  constructor(props) {
    super(props);
    this.state = {};
  }

  formatMessage = (data) => this.props.intl.formatMessage(data);

  showUI = () => {
    const { close, data: {save = () => {}, cancel = () => {}} = {} } = this.props;
    const { formatMessage } = this;

    return (
      <div>
        <div
          className="flex justify-content-end  mt30 mr40 ml40  clickable"
          onClick={close}
        >
          <img src={CloseIcon} alt="close modal" />
        </div>
        <div className="flex columns align-items-center  medium fontsize22 mr20 ml20">
          {`${formatMessage(messages.confirmEditMessage)}\n`}
        </div>

        <div className="flex justify-content-center align-items-center mt20">
          <TertiaryButton
            text={formatMessage(messages.cancel)}
            width="wpx120"
            handleOnClick={close}
          />
          <SecondaryButton
            text={formatMessage(messages.save)}
            width="wpx120"
            marginLeft="ml20"
            marginRight="mr20"
            handleOnClick={() => {save(); close();}}
          />
        </div>
      </div>
    );
  };

  render() {
    const { show } = this.props;
    if (!show) {
      return null;
    }

    return <AcknowledgementLayout>{this.showUI()}</AcknowledgementLayout>;
  }
}

export default injectIntl(editDistributorProductCode);
